export enum ForecastTypeOption {
  Fixed = 'fixed',
  Rolling = 'rolling'
}
export type ForecastKindOption = 'budget' | 'scenario';
export interface ForecastFormError {
  id: string;
  message: string;
}
export type ForecastFormErrors = Record<string, ForecastFormError>;

export enum ForecastFormElementIds {
  Name = 'forecast-name',
  From = 'forecast-from',
  Type = 'forecast-type',
  Duration = 'forecast-duration',
  PreviousActuals = 'forecast-previous-actuals',
  SourceForecast = 'forecast-datasource-forecast',
  Datasource = 'forecast-datasource'
}
